import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/next/app/googleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextTamaguiProvider"] */ "/app/apps/next/app/NextTamaguiProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebProvider"] */ "/app/apps/next/app/Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/app/apps/next/providers/translationsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ninjacart/nc-events-sdk-v2/dist/esm/posthog/posthog.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/ActivityIndicator/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Animated/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Appearance/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AppRegistry/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AppState/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Clipboard/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/createElement/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Dimensions/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Image/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/KeyboardAvoidingView/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Modal/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Pressable/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/render/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/ScrollView/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/TextInput/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useColorScheme/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useLocaleContext/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useWindowDimensions/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/View/index.js");
;
import(/* webpackMode: "eager" */ "/app/packages/nc-nk-core/src/common/scriptBound.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/nc-nk-core/src/common/timeBound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/nk-store/src/context/createFastContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/homeContext/homeContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useComments"] */ "/app/packages/nk-store/src/hooks/useComments.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/hooks/useConnection.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/hooks/useCourseRefreshToken.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRecommendedProducts"] */ "/app/packages/nk-store/src/hooks/useRecommendedProducts.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/hooks/useVideoData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["changeLanguage","default","i18nOptions"] */ "/app/packages/nk-store/src/i18n/i18n.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/provider/globalLoginContext.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/provider/globalMicTabTrigger.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/nk-store/src/provider/globalReportContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["checkLocationPermission"] */ "/app/packages/nk-store/src/store/useLocationPermission.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getUpdateLogs","doUpdateIfAvailable","useCustomUpdater"] */ "/app/packages/nk-store/src/utils/updates.ts");
